import { Component, defineComponent } from '@decify/cell-shopify/client';
import { productCardTagName } from '../ProductCard';
import { toggleChangeEvent, toggleName } from '../Toggle';
import './ProductList.scss';
export const productListName = 'ProductList';
export const productListTagName = 'cell-component-product-list';
export class ProductList extends Component {
    constructor() {
        super(productListName);
        this.handleToggleChange = this.handleToggleChange.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${toggleName}.${toggleChangeEvent}`, this.handleToggleChange);
    }
    handleToggleChange() {
        this.productCards.forEach((productCard) => productCard.toggleImage());
    }
    get productCards() {
        return this.querySelectorAll(productCardTagName);
    }
}
defineComponent(productListTagName, ProductList);
